import { createSelector } from 'reselect';
// import { IGlobalState } from 'types/global';
import { initialState } from './reducer';

const selectApp = (state: any) => state.get('appReducer') || initialState;

const makeSelectToast = () => createSelector(selectApp, (draft) => draft.toast);

const makeSelectSpinnerMessage = () => createSelector(selectApp, (draft) => draft.spinner);
const makeSelectUserInfo = () => createSelector(selectApp, (draft) => draft.userInfo);
const makeSelectLoggedInEmployee = () => createSelector(selectApp, (draft) => draft.loggedInEmployee);

export { selectApp, makeSelectToast, makeSelectSpinnerMessage, makeSelectUserInfo, makeSelectLoggedInEmployee };
